// extracted by mini-css-extract-plugin
module.exports = {"bookModule":"CBBookModule_bookModule__26_x-"};